import React, {useEffect, useState} from 'react';
import {ErrorMessage, Field, Form, Formik} from 'formik';
import {useNavigate} from 'react-router-dom';
import {useDispatch, useSelector} from 'react-redux';
import {toast} from 'react-toastify';
import "pages/users/_userDetail.scss";
import {ROLE_DISPLAY, ROLES} from 'common/constants';
import {api} from 'api/calls';
import ComLoader from 'components/comLoader/ComLoader';
import {routes} from 'common';
import {userValidationSchema} from 'pages/users/constants';
import {generalExtraActions} from 'reduxStore/actions';
import SingleSelect from "../../components/singleSelect/SingleSelect";
import MultiSelect from "../../components/multiSelect/MultiSelect";

function UserCreate() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const {
    subRolesByRole,
    subRolesByRoleLoading,
    subRolesByRoleError,
    grounds,
    groundsLoading,
    groundsError
  } = useSelector((state) => state.general);
  const [loading, setLoading] = useState(false);
  const [expandedLocation, setExpandedLocation] = useState(true);

  const initialValues = {
    full_name: '',
    email: '',
    phone_number: '',
    role: ROLES.PLAYER,
    sub_role: '',
    grounds: [],
    is_active: true,
    // dob: '',
    // location: {
    //   city: '',
    //   address: '',
    //   latitude: '',
    //   longitude: '',
    // },
  };

  const handleSubmit = async (values) => {
    console.log('Creating user with values:', values);
    setLoading(true);
    try {
      const response = await api.createUser(values);
      toast.success('User created successfully!');
      navigate(routes.USERS);
    } catch (error) {
      console.error('Error creating user:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    navigate(routes.USERS);
  };

  const toggleLocationExpansion = () => {
    setExpandedLocation(!expandedLocation);
  };

  useEffect(() => {
    dispatch(generalExtraActions.getCities());
    dispatch(generalExtraActions.getGrounds());
    dispatch(generalExtraActions.getSubRolesByRole());
  }, []);

  return (
    <div className="user-detail-page detail-page">
      <div className="header">
        <h1>Create New User</h1>
        <p className="subtitle">Add a new user to the system</p>
      </div>

      <Formik
        initialValues={initialValues}
        validationSchema={userValidationSchema}
        onSubmit={handleSubmit}
      >
        {({values, errors, touched, setFieldValue}) => {
          console.log(errors)

          return <Form className="custom-form">
            <div className="form-row">
              <div className="form-group">
                <label htmlFor="full_name">
                  Full Name <span className="required">*</span>
                </label>
                <Field
                  type="text"
                  id="full_name"
                  name="full_name"
                  className={`form-control ${touched.full_name && errors.full_name ? 'is-invalid' : ''}`}
                  placeholder="Enter full name"
                />
                <ErrorMessage name="full_name" component="div" className="error-message"/>
              </div>
              <div className="form-group">
                <label htmlFor="email">
                  Email <span className="required">*</span>
                </label>
                <Field
                  type="email"
                  id="email"
                  name="email"
                  className={`form-control ${touched.email && errors.email ? 'is-invalid' : ''}`}
                  placeholder="Enter email address"
                />
                <ErrorMessage name="email" component="div" className="error-message"/>
              </div>

            </div>

            <div className="form-row">

              <div className="form-group">
                <label htmlFor="phone_number">
                  Phone Number <span className="required">*</span>
                </label>
                <Field
                  type="tel"
                  id="phone_number"
                  name="phone_number"
                  className={`form-control ${touched.phone_number && errors.phone_number ? 'is-invalid' : ''}`}
                  placeholder="+923221234567"
                />
                <ErrorMessage name="phone_number" component="div" className="error-message"/>
              </div>
              <div className="form-group">
                <label htmlFor="is_active">
                  Status <span className="required">*</span>
                </label>
                <Field
                  as="select"
                  id="is_active"
                  name="is_active"
                  className={`form-control ${touched.is_active && errors.is_active ? 'is-invalid' : ''}`}
                >
                  <option value={true}>Active</option>
                  <option value={false}>Inactive</option>
                </Field>
                <ErrorMessage name="is_active" component="div" className="error-message"/>
              </div>

            </div>

            <div className="form-row">
              <div className="form-group">
                <label htmlFor="role">
                  Role <span className="required">*</span>
                </label>
                <Field
                  as="select"
                  id="role"
                  name="role"
                  className={`form-control ${touched.role && errors.role ? 'is-invalid' : ''}`}
                >
                  {Object.entries(ROLE_DISPLAY).map(([key, display]) => (
                    <option key={key} value={key}>
                      {display}
                    </option>
                  ))}
                </Field>
                <ErrorMessage name="role" component="div" className="error-message"/>
              </div>

            </div>

            {(values.role === ROLES.ADMIN || values.role === ROLES.GROUND_ADMIN) && (
              <div className="form-group">
                <label htmlFor="sub_role">
                  Subrole <span className="required">*</span>
                </label>
                {subRolesByRoleLoading ? (
                  <div style={{color: '#888', padding: '8px 0'}}>Loading subroles...</div>
                ) : subRolesByRoleError ? (
                  <div style={{color: '#d32f2f', padding: '8px 0'}}>Failed to load subroles</div>
                ) : (
                  <SingleSelect
                    options={
                      values.role === ROLES.ADMIN
                        ? subRolesByRole.admin?.map((sub_role) => ({
                        label: sub_role.name,
                        value: sub_role.id
                      })) || []
                        : subRolesByRole.ground_admin?.map((sub_role) => ({
                        label: sub_role.name,
                        value: sub_role.id
                      })) || []
                    }
                    value={values.sub_role || ''}
                    onChange={(subroleId) => setFieldValue('sub_role', subroleId)}
                    placeholder="Select a subrole"
                    isDisabled={false}
                  />
                )}
                <ErrorMessage name="sub_role" component="div" className="error-message"/>
              </div>
            )}

            {(values.role === ROLES.GROUND_ADMIN) && (
              <div className="form-group">
                <label htmlFor="grounds">
                  Assign Grounds
                </label>
                {groundsLoading ? (
                  <div style={{color: '#888', padding: '8px 0'}}>Loading grounds...</div>
                ) : groundsError ? (
                  <div style={{color: '#d32f2f', padding: '8px 0'}}>Failed to load grounds</div>
                ) : (
                  <MultiSelect
                    options={grounds.map(g => ({label: g.name, value: g.id}))}
                    value={grounds.filter(g => values.grounds.includes(g.id)).map(g => ({label: g.name, value: g.id}))}
                    onChange={selected => setFieldValue('grounds', selected.map(opt => opt.value))}
                    placeholder="Select grounds..."
                  />
                )}
                <ErrorMessage name="grounds" component="div" className="error-message"/>
              </div>
            )}

            {/*<div className="form-group">*/}
            {/*  <label htmlFor="dob">*/}
            {/*    Date of Birth <span className="required">*</span>*/}
            {/*  </label>*/}
            {/*  <Field*/}
            {/*    type="date"*/}
            {/*    id="dob"*/}
            {/*    name="dob"*/}
            {/*    className={`form-control ${touched.dob && errors.dob ? 'is-invalid' : ''}`}*/}
            {/*  />*/}
            {/*  <ErrorMessage name="dob" component="div" className="error-message"/>*/}
            {/*</div>*/}

            {/*/!* Location Section *!/*/}
            {/*<div className="section-header">*/}
            {/*  <div*/}
            {/*    className="section-title-wrapper"*/}
            {/*    onClick={toggleLocationExpansion}*/}
            {/*    style={{cursor: 'pointer'}}*/}
            {/*  >*/}
            {/*    <button*/}
            {/*      type="button"*/}
            {/*      className="expand-btn"*/}
            {/*      onClick={(e) => {*/}
            {/*        e.stopPropagation();*/}
            {/*        toggleLocationExpansion();*/}
            {/*      }}*/}
            {/*      aria-label={expandedLocation ? 'Collapse location' : 'Expand location'}*/}
            {/*    >*/}
            {/*      <span className={`expand-icon ${expandedLocation ? 'expanded' : ''}`}>*/}
            {/*        {expandedLocation ? <IoChevronUp/> : <IoChevronDown/>}*/}
            {/*      </span>*/}
            {/*    </button>*/}
            {/*    <h2>Location Information</h2>*/}
            {/*  </div>*/}
            {/*</div>*/}

            {/*{expandedLocation && (*/}
            {/*  <div className="location-content">*/}
            {/*    <div className="form-group">*/}
            {/*      <label htmlFor="location.address">*/}
            {/*        Address <span className="required">*</span>*/}
            {/*      </label>*/}
            {/*      <Field*/}
            {/*        as="textarea"*/}
            {/*        id="location.address"*/}
            {/*        name="location.address"*/}
            {/*        className={`form-control ${touched.location?.address && errors.location?.address ? 'is-invalid' : ''}`}*/}
            {/*        placeholder="Enter address"*/}
            {/*        rows="3"*/}
            {/*      />*/}
            {/*      <ErrorMessage name="location.address" component="div" className="error-message"/>*/}
            {/*    </div>*/}
            {/*    <div className="form-group">*/}
            {/*      <label htmlFor="location.city">*/}
            {/*        City <span className="required">*</span>*/}
            {/*      </label>*/}
            {/*      <Field*/}
            {/*        as="select"*/}
            {/*        id="location.city"*/}
            {/*        name="location.city"*/}
            {/*        className={`form-control ${touched.location?.city && errors.location?.city ? 'is-invalid' : ''}`}*/}
            {/*        disabled={citiesLoading}*/}
            {/*      >*/}
            {/*        <option value="">Select a city</option>*/}
            {/*        {cities.map((city) => (*/}
            {/*          <option key={city.id} value={city.id}>*/}
            {/*            {city.name}*/}
            {/*          </option>*/}
            {/*        ))}*/}
            {/*      </Field>*/}
            {/*      {citiesLoading && <div className="loading-text">Loading cities...</div>}*/}
            {/*      <ErrorMessage name="location.city" component="div" className="error-message"/>*/}
            {/*    </div>*/}
            {/*    <div className="form-row">*/}
            {/*      <div className="form-group">*/}
            {/*        <label htmlFor="location.latitude">*/}
            {/*          Latitude*/}
            {/*        </label>*/}
            {/*        <Field*/}
            {/*          type="number"*/}
            {/*          id="location.latitude"*/}
            {/*          name="location.latitude"*/}
            {/*          className={`form-control ${touched.location?.latitude && errors.location?.latitude ? 'is-invalid' : ''}`}*/}
            {/*          placeholder="Enter latitude"*/}
            {/*          step="any"*/}
            {/*        />*/}
            {/*        <ErrorMessage name="location.latitude" component="div" className="error-message"/>*/}
            {/*      </div>*/}
            {/*      <div className="form-group">*/}
            {/*        <label htmlFor="location.longitude">*/}
            {/*          Longitude*/}
            {/*        </label>*/}
            {/*        <Field*/}
            {/*          type="number"*/}
            {/*          id="location.longitude"*/}
            {/*          name="location.longitude"*/}
            {/*          className={`form-control ${touched.location?.longitude && errors.location?.longitude ? 'is-invalid' : ''}`}*/}
            {/*          placeholder="Enter longitude"*/}
            {/*          step="any"*/}
            {/*        />*/}
            {/*        <ErrorMessage name="location.longitude" component="div" className="error-message"/>*/}
            {/*      </div>*/}
            {/*    </div>*/}
            {/*  </div>*/}
            {/*)}*/}

            <div className="actions-section">
              <button
                className="submit-btn primary"
                type="submit"
                disabled={loading}
              >
                {loading ? <ComLoader/> : "Create User"}
              </button>

              <button
                className="submit-btn secondary"
                type="button"
                onClick={handleCancel}
                disabled={loading}
              >
                Cancel
              </button>
            </div>
          </Form>
        }}
      </Formik>
    </div>
  );
}

export default UserCreate;